import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/logo-new.png";
import cartImg from "../../assets/cart.png";
import { routes } from "../../helpers/Routes";

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Badge from '@mui/material/Badge';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { useProductos } from "../../hooks/useProductos";

function Header({ setOpenCart, openCart }) {
  const [open, setOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const { cart } = useProductos();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleDrawer = (newOpen) => setOpen(newOpen);

  const DrawerList = (
    <Box sx={{ width: 250 }} role="presentation" onClick={() => toggleDrawer(false)}>
      <List>
        {[{ text: 'Bicicletas', link: routes.bicicletas }, { text: 'Nosotros', link: routes.nosotros }, { text: 'Contacto', link: routes.contacto }, { text: 'FAQ', link: routes.faq }].map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton>
              <Link to={item.link} style={{ color: "#fff" }}>
                <ListItemText primary={item.text} />
              </Link>
            </ListItemButton>
          </ListItem>
        ))}
        <ListItem key="EcoRiders" disablePadding>
          <ListItemButton>
            <a href="https://ecoriders.co/" style={{ color: "#fff" }}>
              <ListItemText primary="EcoRiders" />
            </a>
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );

  return (
    <>
      <AppBar position="static">
        <header className={isScrolled ? "scrolled-header" : ""}>
          <div className="navbar-nav">
            <Container maxWidth="xl">
              <Toolbar disableGutters>

                {/* Logo en versión desktop */}
                <Typography
                  variant="h6"
                  noWrap
                  component="div"
                  sx={{
                    mr: 2,
                    display: { xs: 'none', md: 'flex' },
                    fontFamily: 'monospace',
                    fontWeight: 700,
                    letterSpacing: '.3rem',
                    color: 'inherit',
                    textDecoration: 'none',
                  }}
                >
                  <Link to={routes.home}><img src={logo} width={200} alt="Logo" /></Link>
                </Typography>

                {/* Responsive: menú y carrito */}
                <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' }, justifyContent: 'space-between', alignItems: 'center' }}>
                  <IconButton
                    size="large"
                    aria-label="menu"
                    onClick={() => toggleDrawer(true)}
                    color="inherit"
                  >
                    <MenuIcon />
                  </IconButton>
                  <Link to={routes.home}><img src={logo} width={150} alt="Logo" /></Link>
                  <IconButton onClick={() => setOpenCart(!openCart)} color="inherit">
                    <Badge badgeContent={cart?.length} color="primary">
                      <img src={cartImg} width={24} height={24} alt="Carrito" />
                    </Badge>
                  </IconButton>
                </Box>

                {/* Navegación en desktop */}
                <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }} className="nav">
                  <div className="nav-links">
                    <Link to={routes.bicicletas}>Bicicletas</Link>
                    <Link to={routes.nosotros}>Nosotros</Link>
                    <Link to={routes.contacto}>Contacto</Link>
                    <Link to={routes.faq}>FAQ</Link>
                    <a href="https://ecoriders.co/">EcoRiders</a>
                  </div>
                </Box>

                {/* Carrito en desktop */}
                <Box sx={{ flexGrow: 0 }} className="nav-links links-auth">
                  <IconButton onClick={() => setOpenCart(!openCart)} color="inherit">
                    <Badge badgeContent={cart?.length} color="primary">
                      <img src={cartImg} width={24} height={24} alt="Carrito" />
                    </Badge>
                  </IconButton>
                </Box>

              </Toolbar>
            </Container>
          </div>
        </header>
      </AppBar>

      <Drawer open={open} onClose={() => toggleDrawer(false)}>
        {DrawerList}
      </Drawer>
    </>
  );
}

export default Header;